import React from 'react'
import { navigate } from 'gatsby'
import intl from 'react-intl-universal'
import { LocaleService } from '@raysync/common/services'
import { LargeWrapper, Row, Column, SEO, Button, Pagination, PaginationType, Swiper } from '@raysync/common/components'
import Layout from '../components/layout'
import { SideBarTitle } from '../style/post.atom'
import { CardContainer, DescColumn, PaginationWrapper, SearchWrap, BannerWrap } from '../style/index.atom'
import { CmsPostCard, HotCard } from '../components/main/cms'
import TagBox from '../components/main/tag-box'
import Categories from '../components/main/categories'
import { Banner } from '../components/main/banner'

class Index extends React.PureComponent {
  constructor(props) {
    super(props)
    let { pageContext } = this.props
    this.cardList = pageContext.posts
  }

  handleSearch = () => {
    const value = document.getElementById('search-text').value
    if (!value) return
    navigate(`/news/search?keyword=${value}&page=1`)
  }

  render() {
    const { location, pageContext } = this.props

    const { terms, categories, hotNews, newsBanners } = pageContext
    const seoTitle = {
      term: pageContext.seoTitle || intl.get('news.seo.title', { title: pageContext.name }),
      category: intl.get('news.seo.title', { title: pageContext.name }),
      news: intl.get('news.seo.title', { title: intl.get('news.title') }),
    }[pageContext.type]
    const seoDescription = pageContext.seoDescription || intl.get('news.seo.desc')
    const seoKeywords = pageContext.seoKeywords || intl.get('news.seo.keywords')

    return (
      <Layout location={location} showBanner>
        <SEO title={seoTitle} description={seoDescription} keywords={seoKeywords} />
        <Banner></Banner>
        <LargeWrapper>
          <Row>
            <Column lg='8.2' xs='12'>
              <Categories data={categories} location={location} />
              <CardContainer>
                {this.cardList &&
                  this.cardList.map(node => {
                    return (
                      <CmsPostCard
                        tags={node.tags}
                        title={node.title}
                        content={
                          node.content && node.content.content ? node.content.content : node.tinyContent.tinyContent
                        }
                        slug={node.slug}
                        date={node.legacyDate || node.createdAt}
                        key={node.id}
                      />
                    )
                  })}
                <PaginationWrapper>
                  <Pagination
                    type={PaginationType.Static}
                    currentPage={pageContext.currentPage}
                    total={pageContext.numPages}
                  />
                </PaginationWrapper>
              </CardContainer>
            </Column>
            <DescColumn lg='3.8' xs='0'>
              <SideBarTitle>{intl.get('news.keywords')}</SideBarTitle>
              {!LocaleService.isForeign && (
                <SearchWrap>
                  <input
                    id='search-text'
                    type='text'
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        this.handleSearch()
                      }
                    }}
                  />
                  <Button onClick={this.handleSearch}>{intl.get('news.search')}</Button>
                </SearchWrap>
              )}
              <TagBox data={terms}></TagBox>
              {!LocaleService.isForeign && (
                <>
                  <BannerWrap>
                    <Swiper swiperNavType='dot'>
                      {newsBanners.map((banner, index) => (
                        <a key={index} href={banner.url}>
                          <img src={banner.img} alt={banner.title} style={{ width: '380px', height: '240px' }} />
                        </a>
                      ))}
                    </Swiper>
                  </BannerWrap>
                  <SideBarTitle>{intl.get('news.recent-list')}</SideBarTitle>
                  <div>
                    {hotNews.map(news => (
                      <HotCard {...news} key={news.title} />
                    ))}
                  </div>
                </>
              )}
            </DescColumn>
          </Row>
        </LargeWrapper>
      </Layout>
    )
  }
}

export default Index
